import React from "react";
import { contactColumnsConfig } from "../config/Contacts";

export const getContactColumns = () => {
  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    } catch (error) {
      return dateString;
    }
  };

  return [
    {
      name: <span className="font-weight-bold fs-13">{contactColumnsConfig.FULL_NAME}</span>,
      selector: (row) => row.fullName || "-",
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">{contactColumnsConfig.EMAIL}</span>,
      selector: (row) => row.email || "-",
    },
    {
      name: <span className="font-weight-bold fs-13">{contactColumnsConfig.PHONE}</span>,
      selector: (row) => row.phoneNumber || "-",
      cell: (row) => (
        <span title={row.phoneNumber}>
          {row.phoneNumber ? (row.phoneNumber.length > 50 ? `${row.phoneNumber.substring(0, 50)}...` : row.phoneNumber) : "-"}
        </span>
      ),
    },
    {
      name: <span className="font-weight-bold fs-13">{contactColumnsConfig.MESSAGE}</span>,
      selector: (row) => row.message || "-",
      cell: (row) => (
        <span title={row.message}>
          {row.message ? (row.message.length > 80 ? `${row.message.substring(0, 80)}...` : row.message) : "-"}
        </span>
      ),
    },
    {
      name: <span className="font-weight-bold fs-13">{contactColumnsConfig.CREATED_AT}</span>,
      selector: (row) => row.createdAt || row.created_at || "",
      sortable: true,
      cell: (row) => formatDate(row.createdAt || row.created_at),
    },
    {
      name: <span className="font-weight-bold fs-13">{contactColumnsConfig.ACTIONS || "Actions"}</span>,
      sortable: false,
      cell: (row) => (
        <div className="d-flex align-items-center justify-content-center">
          <a
            href={`mailto:${row.email || ""}`}
            onClick={(event) => event.stopPropagation()}
            className="text-decoration-none"
            title="Reply via email"
          >
            <i className="ri-mail-send-line fs-13 text-primary p-2 rounded-circle shadow-sm bg-f1" />
          </a>
        </div>
      ),
      width: "120px",
    },
  ];
};